/**
 * Flattens text to plain lowercase words so a search for the label a user sees
 * ("X2Earn Reward", "Mugshot · Pro") also matches the raw classification
 * ("x2earn_reward", "mugshot_pro_subscription") and vice versa.
 */
export function normalizeSearchText(value) {
  return String(value ?? "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ")
    .trim();
}

/**
 * Zeigt die Klassifikation lesbar (Title Case) — Fallback ohne App-Icons.
 */
export function formatClassificationTitleCase(tx) {
  const raw = String(tx?.classification || tx?.type || "—");
  return raw
    .replace(/_/g, " ")
    .split(" ")
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(" ")
    .replace(/\bVebetterdao\b/g, "VeBetterDAO");
}
